import { PLATFORMS_CODES } from '@/constants/languages'
import { IShotlist } from '@/types/shotlist.interface'
import { ILanguage } from '@/types/task.interface'
import {
	ISelectedPlatform,
	TPlatformValue
} from '@/types/uploadForm.interface'

export const getSourceNameFromShotlist = (
	shotlist?: IShotlist | null,
	selectedPlatform?: TPlatformValue | null,
	selectedPlatformList?: ISelectedPlatform[],
	languages?: ILanguage[]
): string => {
	const original = shotlist?.original

	if (!original) return ''

	const firstPlatform = selectedPlatformList?.[0]?.value
	const isFirstPlatform =
		!selectedPlatform || !firstPlatform || selectedPlatform === firstPlatform

	if (!isFirstPlatform) {
		const selectedLanguage = PLATFORMS_CODES[selectedPlatform]
		const translation = shotlist?.translations?.find(
			item => item.language === selectedLanguage
		)

		if (translation?.filename) return translation.filename
	}

	if (original.filename) return original.filename

	if (original.content && original.language) {
		return (
			languages?.find(language => language.code === original.language)?.language ||
			original.language
		)
	}

	return ''
}
